export default {
  segment_labels: {
    active: 'Active',
    cancelled: 'Cancelled',
    completed: 'Completed',
  },
};
